import React, { Fragment } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import AppFooter from "../../Layout/AppFooter";
// Pages
import PortfolioDashboard from "./PortfolioDashboard";
import AccountDashboard from "./AccountDashboard";
import TradeDetail from "../trading/TradeDetail";
import StrategySummary from "../strategy/StrategySummary";
import OrderHistory from "../trading/OrderHistory";
import OptionPositions from "../trading/OptionPositions";
import PnLPage from "../trading/PnLPage";

import StrategyBuild from "../strategy/StrategyBuild";
import StrategyJobs from "../strategy/StrategyJobs";
import StrategyManage from "../strategy/StrategyManage";
import PortfolioBuilder from "../strategy/PortfolioBuilder";

import RuleBuilderPage from "../rules/RuleBuilderPage";
import RuleTemplatesPage from "../rules/RuleTemplatesPage";
import SystemSettingsPage from "../settings/SystemSettingsPage";
import MarketReplayPage from "../settings/MarketReplayPage";
import ProfilePage from "../profile/ProfilePage";
import ConnectBrokeragePage from "../brokerage/ConnectBrokeragePage";
import NotificationsPage from "../profile/NotificationsPage";
import AdminPage from "../admin/AdminPage";
import AuditPage from "../admin/AuditPage";
import SystemHealthPage from "../admin/SystemHealthPage";
import ReplayConfigPage from "../admin/ReplayConfigPage";
import BrandingSettingsPage from "../admin/BrandingSettingsPage";
import PriceAlertsPage from "../alerts/PriceAlertsPage";
import SuggestionsPage from "../automation/SuggestionsPage";
import HistoryPage from "../automation/HistoryPage";
import OrderQueuePage from "../automation/OrderQueuePage";
import BacktestConfig from "../backtest/BacktestConfig";
import InteractiveBacktest from "../backtest/InteractiveBacktest";
import BacktestReplay from "../backtest/BacktestReplay";
import ChatPage from "../support/ChatPage";
import AIChatPage from "../support/AIChatPage";
import SupportTicketsPage from "../support/SupportTicketsPage";
import AdminChatView from "../support/AdminChatView";
import AdminChatSessionList from "../support/AdminChatSessionList";
import PageHelpBubble from "../../components/chat/PageHelpBubble";
import ChatWidget from "../../components/chat/ChatWidget";
import { ChatProvider } from "../../context/ChatContext";
import SubscriptionBanner from "../../components/SubscriptionBanner";
//import StrategyHistory from "../strategy/StrategyHistory";

const DashboardLayout = () => {
  return (
    <ChatProvider>
    <Fragment>
      <AppHeader />

      <div className="app-main">
        <AppSidebar />

        <div className="app-main__outer">
          <div className="app-main__inner">
            <Switch>
              {/* ===== DASHBOARD ===== */}
              <Route exact path="/dashboard" component={AccountDashboard} />

              {/* ===== STRATEGY ===== */}
              <Route exact path="/strategy/build" component={StrategyBuild} />
              <Route exact path="/strategy/portfolio-builder" component={PortfolioBuilder} />
              <Route exact path="/strategy/jobs" component={StrategyJobs} />
              <Route exact path="/strategy/manage" component={StrategyManage} />

              {/* ===== RULES ===== */}
              <Route exact path="/rules/builder" component={RuleBuilderPage} />
              <Route exact path="/rules/templates" component={RuleTemplatesPage} />

              {/* ===== SETTINGS ===== */}
              <Route exact path="/system/settings" component={SystemSettingsPage} />
              <Route exact path="/system/replay" component={MarketReplayPage} />

              {/* ===== AUTOMATION ===== */}
              <Route exact path="/automation/suggestions" component={SuggestionsPage} />
              <Route exact path="/automation/history"     component={HistoryPage} />
              <Route exact path="/automation/orders"      component={OrderQueuePage} />

              {/* ===== PROFILE ===== */}
              <Route exact path="/profile" component={ProfilePage} />
              <Route exact path="/brokerage" component={ConnectBrokeragePage} />
              <Route exact path="/profile/notifications" component={NotificationsPage} />

              {/* ===== ADMIN ===== */}
              <Route exact path="/admin/users" component={AdminPage} />
              <Route exact path="/admin/audit" component={AuditPage} />
              <Route exact path="/admin/system/health" component={SystemHealthPage} />
              <Route exact path="/admin/replay" component={ReplayConfigPage} />
              <Route exact path="/admin/branding" component={BrandingSettingsPage} />
              {/* legacy redirect */}
              <Redirect from="/strategy/rules" to="/rules/builder" />

              {/* ===== ALERTS ===== */}
              <Route exact path="/alerts/price" component={PriceAlertsPage} />

              {/* ===== TRADING ===== */}
              <Route exact path="/trading/positions" component={PortfolioDashboard} />
              <Route exact path="/trading/option-positions" component={OptionPositions} />
              <Route exact path="/trading/strategy-summary" component={StrategySummary} />
              <Route exact path="/trading/orders" component={OrderHistory} />
              <Route exact path="/trading/pnl" component={PnLPage} />
              <Route path="/trading/:stockname" component={TradeDetail} />

              {/* ===== BACKTEST ===== */}
              <Route exact path="/backtest" component={BacktestConfig} />
              <Route path="/backtest/interactive/:sessionId" component={InteractiveBacktest} />
              <Route path="/backtest/replay/:jobId" component={BacktestReplay} />

              {/* ===== SUPPORT ===== */}
              <Route exact path="/tutorials" component={ChatPage} />
              <Route exact path="/chat" component={AIChatPage} />
              <Route exact path="/support/tickets" component={SupportTicketsPage} />
              <Route exact path="/admin/chat/:sessionId" component={AdminChatView} />
              <Route exact path="/admin/chat" component={AdminChatSessionList} />

              {/* ===== DEFAULT ===== */}
              <Redirect to="/dashboard" />
            </Switch>
          </div>

          <AppFooter />
        </div>
      </div>

      {/* ── subscription expiry bubble — dismissible ── */}
      <SubscriptionBanner />

      {/* ── contextual help bubble — route-aware, top-right ── */}
      <PageHelpBubble />

      {/* ── AI chat floating widget ── */}
      <ChatWidget />
    </Fragment>
    </ChatProvider>
  );
};

export default DashboardLayout;
